import { useEffect, useState } from "react";

/**
 * Persisted view-mode toggle (e.g. "card" vs "list") backed by localStorage.
 * Reusable across Clients, Projects, etc.
 */
export default function useViewMode(key, defaultMode = "card") {
  const storageKey = `co_view_${key}`;
  const [mode, setMode] = useState(() => {
    try { return localStorage.getItem(storageKey) || defaultMode; }
    catch { return defaultMode; }
  });
  useEffect(() => {
    try { localStorage.setItem(storageKey, mode); } catch { /* ignore */ }
  }, [mode, storageKey]);
  return [mode, setMode];
}
